import React, { useState, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Canvas from "../canvas";
import { useBoardFile } from "../../context/boardFileContext";
import { useCanvas } from "../../context/canvasContext";
import { v1 as uuid } from "uuid";
import { debounce } from 'lodash';

import {
  addObj,
  addPath,
  addText,
  emitCanvasFile,
  emitDrawingPath,
  emitModify,
  modifyObj,
  removeObject,
  addImage,
  emitClonedObj,
  addClonedObject,
  addToGroup,
  emitRoomID,
  emitCanvasData,
  onBackgroundColorChange,
  clearCanvasListen,
  onShapeColorChange,
  ListenUndo,
  ListenRedo,
  reloadStack,
  listenSendToBack,
  listenBringToFront,
  onStrokeColorChange,
  listenUngroup,
  emitDeleteObject,
  listenUpdateAll
} from "../../socket";
import axios from "axios";
import { boardServices, workwiseServices, templateService } from "../../api";
import { useDocument } from "../../context/documentInfoContex";
import { formatFileSize, isOffline, removeOfflineData, saveToLocalStorage, processTemplateData, removeTemplateIdFromURL } from "../../utils/helper";
import WaterMark from "../WaterMark";
import Loader from "../SkeletonLoader/skeletonLoader";
import { message } from "antd";
import CompressionConfirmModal from "../ImageCompressionModal/CompressionConfirmModal";



const CanvasWrapper = ({ contentLoading, setContentLoading }) => {
  const { saveBoardData, loadBoardFile, boardFileName } = useBoardFile();
  const [update, setUpdate] = useState(null)
  const {
    canvasRef,
    prepareCanvas,
    createGrid,
    Panning,
    createImage,
    registerBoardImageUpload,
    getActiveObject,
    saveStateToUndoStack,
    undoStack,
    redoStack,
    reloadStack,
    saveStateToReloadStack,
    savingLastChanges,
    lastChange,
    userInfo
  } = useCanvas();

  const {
    setSavingData,
    isReadOnly,
    setIsExternalAllow,
    documentInfo,
    setIsConflictModalVisible,
    setServerData,
    isConflictModalVisible,
    isLoadingVersion,
    conflictPreviewVerion,
    boardData,
    setBoardData,
    isTemplateDocument,
    setTemplateData
  } = useDocument();

  let { id } = useParams();
  const history = useHistory();
  const [movementData, setMovementData] = useState();
  const [boardCompressOpen, setBoardCompressOpen] = useState(false);
  const [boardCompressFileSize, setBoardCompressFileSize] = useState(0);
  const boardCompressChoiceRef = useRef(null);
  const BOARD_COMPRESS_MODAL_Z = 10050;

  const closeBoardCompressModal = (choice) => {
    setBoardCompressOpen(false);
    const pending = boardCompressChoiceRef.current;
    boardCompressChoiceRef.current = null;
    if (!pending) return;

    if (choice === 'cancel') {
      pending.reject(Object.assign(new Error('cancelled'), { isCancel: true }));
      return;
    }

    message.loading({
      content:
        choice === 'compress'
          ? 'Compressing and uploading image...'
          : 'Uploading original image...',
      key: 'board-image-upload',
    });
    pending.resolve(choice === 'compress');
  };

  useEffect(() => {
    registerBoardImageUpload({
      promptCompress: (largeFile) => {
        message.destroy('board-image-upload');
        return new Promise((resolve, reject) => {
          setBoardCompressFileSize(largeFile.size);
          boardCompressChoiceRef.current = { resolve, reject };
          setBoardCompressOpen(true);
        });
      },
    });
    return () => registerBoardImageUpload(null);
  }, [registerBoardImageUpload]);

  const url_string = window.location.href; //window.location.href
  const url = new URL(url_string);
  const mileboardName = url.searchParams.get("mileboardname");
  //Send the id to the server.
  //Checks if the board exists, if not. It creates the board.
  //If it does, it loads the while.
  React.useEffect(() => {
    //emitCanvasFile(id);
    !isOffline() && emitRoomID(id);
  }, [id]);

  //UseEffect to hit the Workwise Api

  // const [saveDocumentDebounced] = useState(() =>
  //   debounce((boardId) => {
  //     const saved='Saved'
  //   savingLastChanges(saved)
  //   return workwiseServices.saveDocumentlastUpdate(boardId)}, 2000)
  // );

  // useEffect(() => {
  //   // Save Debouned after user has stopped activity
  //   if (boardData) {
  //     saveDocumentDebounced(id);
  //     return saveDocumentDebounced.cancel; // Clean up by canceling debounce on unmount
  //   }
  // }, [boardData, id, saveDocumentDebounced]);

  // React.useEffect(()=>{
  //   const saved='Saving...'
  //   if (boardData) {

  //     savingLastChanges(saved)
  //   } 
  // },[boardData])

  const baseURL = 'https://board.workw.com/api/';
  // const baseURL = "http://localhost:3000/api/";
  const hasInitializedRef = React.useRef(false);

  useEffect(() => {
    if (!hasInitializedRef.current) {
      prepareCanvas(id);
      hasInitializedRef.current = true;
    }

    const loadData = async () => {
      if (!canvasRef.current) return;
      setContentLoading(true);


      function loadDataIntoCanvas(data) {

        if (!canvasRef?.current || !data) return;

        canvasRef.current.loadFromJSON(data, () => {
          canvasRef.current.renderAll();
          saveStateToReloadStack();
          setContentLoading(false);
        });
      }

      const fetchAndLoadTemplate = async (templateId, options = {}) => {
        const { shouldSetTemplateData = false, shouldRemoveFromURL = false } = options;
        const serverResponse = await templateService.fetchTemplateById(templateId);
        const templateData = processTemplateData(serverResponse);

        if (shouldRemoveFromURL) {
          removeTemplateIdFromURL(history);
        }

        if (shouldSetTemplateData) {
          setTemplateData(templateData);
        }

        loadDataIntoCanvas(templateData.mileboardData || serverResponse);

        if (!shouldSetTemplateData) {
          setIsExternalAllow(templateData?.isExternal || false);
          setSavingData({
            isSaving: "",
            lastSavedDateTime: "",
            fileSize: formatFileSize(new TextEncoder().encode(JSON.stringify(templateData.mileboardData)).length),
          });
          // Save the template data to the board database
          await boardServices.updateBoardData(id, templateData.mileboardData, setSavingData, false);
        }
      };

      try {

        if (isTemplateDocument) {
          await fetchAndLoadTemplate(id, { shouldSetTemplateData: true });
          return;
        }

        const searchParams = new URLSearchParams(window.location.search);
        const templateId = searchParams.get('templateId');
        if (templateId) {
          await fetchAndLoadTemplate(templateId, { shouldRemoveFromURL: true });
          return;
        }

        const offlineBoard = JSON.parse(localStorage.getItem("offlineBoardData") || "{}");
        const localData = offlineBoard[id]?.data || null;
        const localDate = offlineBoard[id]?.lastUpdateTime ? new Date(offlineBoard[id].lastUpdateTime) : null;

        const serverBoardData = await boardServices.getBoardData(id);
        const serverCanvasData = serverBoardData?.mileboardData?.[0] || null;
        const serverDate = serverBoardData?.updatedAt ? new Date(serverBoardData.updatedAt) : null;
        setServerData(serverBoardData);

        let finalData = null;

        // 1. Preview mode chosen from conflict modal
        if (conflictPreviewVerion) {

          finalData = conflictPreviewVerion === "offline" ? localData : serverCanvasData;
          loadDataIntoCanvas(finalData);
          return;
        }

        // 2. Conflict: both exist, server newer
        if (localData && serverCanvasData && serverDate && localDate && serverDate > localDate) {
          setIsConflictModalVisible(true);
          setContentLoading(false);
          return;
        }

        // 3. Local is newer
        if (localData && (!serverCanvasData || (serverDate && localDate && localDate > serverDate))) {
          finalData = localData;
          loadDataIntoCanvas(localData);
          await boardServices.updateBoardData(id, localData, setSavingData, false);
          removeOfflineData(id);
          return;
        }

        // 4. Only server available
        if (serverCanvasData) {
          finalData = serverCanvasData;
          loadDataIntoCanvas(serverCanvasData);
          return;
        }

        // 5. No data at all
        setContentLoading(false);

        // Update metadata if we had data
        if (finalData) {
          setIsExternalAllow(finalData?.isExternal || false);
          setSavingData({
            isSaving: "",
            lastSavedDateTime: "",
            fileSize: formatFileSize(new TextEncoder().encode(JSON.stringify(finalData)).length),
          });
        }

      } catch (error) {
        console.error(`Error loading board ${id}:`, error);
        setContentLoading(false);
      }

    };

    loadData();

    return () => {
      // Cleanup if needed
    };
  }, [id, conflictPreviewVerion, isTemplateDocument]);

  React.useEffect(() => {
    //loadBoardFile(id, canvasRef);
    const createBoard = async (id, canvasRef) => {
      if (isTemplateDocument) return; // Skip API call for template documents

      try {
        const response = await axios.post(
          `${baseURL}boards/create`,
          { id }
        );

      } catch (error) {
        console.log(error);
      }
    };
    createBoard(id, canvasRef);
  }, [id, canvasRef, isTemplateDocument]);


  useEffect(() => {
    const handleKeyDown = (e) => {
      const activeElement = document.activeElement;
      const isInput =
        activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        activeElement.isContentEditable;

      // Prevent triggering delete while typing in inputs
      if (isInput) return;

      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

      const isDeleteKey =
        e.key === 'Delete' ||
        (!isMac && e.key === 'Backspace') ||
        (isMac && e.key === 'Backspace' && e.metaKey); // Cmd + Backspace on Mac

      if (isDeleteKey) {
        e.preventDefault();
        deleteSelected();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const deleteSelected = () => {
    const activeObjects = canvasRef.current._activeObject;
    if (activeObjects) {
      if (activeObjects.type == 'group') {
        let removedObjID = activeObjects.id;
        canvasRef.current.remove(activeObjects);
        !isOffline() && emitDeleteObject(removedObjID);

      }
      if (activeObjects._objects) {
        activeObjects._objects.forEach((object) => {
          let removedObjID = object.id;
          canvasRef.current.remove(object);
          !isOffline() && emitDeleteObject(removedObjID);
        });
      } else {
        let removedObjID = activeObjects.id;
        canvasRef.current.remove(activeObjects);
        !isOffline() && emitDeleteObject(removedObjID);
      }
    }
    let canvasData = canvasRef.current.toJSON(["selectable", "id", "type"]);
    !isOffline() && emitCanvasData(id, canvasData)
    canvasRef.current.discardActiveObject().renderAll();
    saveStateToUndoStack();
  }

  React.useEffect(() => {
    const onDragOver = (event) => {
      event.stopPropagation();
      event.preventDefault();
      event.dataTransfer.dropEffect = "copy";
    };

    const onDrop = (event) => {
      if (isReadOnly) return;
      event.stopPropagation();
      event.preventDefault();
      const files = event.dataTransfer.files;
      for (const file of files) {
        if (file.type && !file.type.startsWith("image/")) {
          continue;
        }
        void createImage(file, id, setSavingData, isTemplateDocument);
      }
    };

    const pasteItem = async () => {
      if (isReadOnly) return;
      try {
        const clipboardItems = await navigator.clipboard.read();
        for (const clipboardItem of clipboardItems) {
          for (const type of clipboardItem.types) {
            if (!type.startsWith("image/")) {
              continue;
            }
            const blob = await clipboardItem.getType(type);
            const file = new File([blob], "pasted.png", { type: blob.type || "image/png" });
            void createImage(file, id, setSavingData, isTemplateDocument);
          }
        }
      } catch (err) {
        console.error(err.name, err.message);
      }
    };

    window.addEventListener("dragover", onDragOver);
    window.addEventListener("drop", onDrop);
    window.addEventListener("paste", pasteItem);
    return () => {
      window.removeEventListener("dragover", onDragOver);
      window.removeEventListener("drop", onDrop);
      window.removeEventListener("paste", pasteItem);
    };
  }, [canvasRef, createImage, isReadOnly, id, setSavingData, isTemplateDocument]);

  React.useEffect(() => {
    Panning(id);
  }, [Panning]);

  //React.useEffect(() => {
  //  createGrid();
  //}, [createGrid]);



  //resize canvas according to screensize.
  // React.useEffect(() => {
  //   const resizeCanvas = () => {
  //     canvasRef.current.setDimensions({
  //       width: width,
  //       height: height,
  //     });
  //     canvasRef.current.renderAll();
  //   };
  //   window.addEventListener("resize", resizeCanvas);
  //   return () => window.removeEventListener("resize", resizeCanvas);
  // }, [canvasRef, width, height]);

  //event listeners for canvas
  React.useEffect(() => {

    if (isLoadingVersion.current) return;

    if (canvasRef && !isConflictModalVisible && !conflictPreviewVerion) {

      //Executed when an object is modified, i.e the dimensions,color etc.
      canvasRef.current.on("object:modified", function (options) {

        if (isLoadingVersion.current) return;

        if (options.target) {
          const modifiedObj = {
            obj: options.target,
            id: options.target.id,
          };
          // console.log(canvasRef.current.toJSON(modifiedObj));
          setBoardData(canvasRef.current.toJSON(["selectable", "id", "type"]));
          !isOffline() && emitModify(id, modifiedObj);
          //saveBoardData(id, canvasRef);
        }
      });
      //Executed when text is changed.
      canvasRef.current.on("text:changed", function (options) {

        if (isLoadingVersion.current) return;

        if (options.target) {
          const modifiedTxt = {
            obj: options.target,
            id: options.target.id,
          };
          // console.log(modifiedTxt);
          // console.log(canvasRef.current.toJSON(modifiedTxt));
          setBoardData(canvasRef.current.toJSON(["selectable", "id", "type"]));
          !isOffline() && emitModify(id, modifiedTxt);
          saveBoardData(id, canvasRef);
        }
      });
      //Executed when the object is moving.
      canvasRef.current.on("object:moving", function (options) {

        if (isLoadingVersion.current) return;

        if (options.target) {
          const modifiedObj = {
            obj: options.target,
            id: options.target.id,
          };
          // console.log(canvasRef.current.toJSON(modifiedObj));
          setBoardData(canvasRef.current.toJSON(["selectable", "id", "type"]));
          setMovementData(modifiedObj);
          // emitModify(modifiedObj);
          saveBoardData(id, canvasRef);
        }
      });
      canvasRef.current.on("path:created", function (e) {

        if (isLoadingVersion.current) return;

        let path = e.path;
        path.set({ id: uuid() });
        path.set({ type: "path" });
        // console.log(canvasRef.current.toJSON({path}));
        setBoardData(canvasRef.current.toJSON(["selectable", "id", "type"]));
        saveStateToUndoStack()                  //Path created with pen tool saves in UndoStack here                     //Implemented to make Undo Redo work for Pen tool
        !isOffline() && emitDrawingPath({ room: id, path, id: path.id });
        saveBoardData(id, canvasRef);
      });
      canvasRef.current.on("object:removed", function (e) {

        if (isLoadingVersion.current) return;

        setBoardData(canvasRef.current.toJSON(["selectable", "id", "type"]));
      });

      modifyObj(canvasRef, saveStateToUndoStack, setBoardData);
      addObj(canvasRef, saveStateToUndoStack, setBoardData);
      addText(canvasRef, saveStateToUndoStack, setBoardData);
      addPath(canvasRef, saveStateToUndoStack, setBoardData);
      removeObject(canvasRef, saveStateToUndoStack, setBoardData);
      addImage(canvasRef, saveStateToUndoStack, setBoardData);
      addClonedObject(canvasRef, saveStateToUndoStack, setBoardData);
      addToGroup(canvasRef, saveStateToUndoStack, setBoardData);
      //Below Function is Socket Listener Function which listens to background changes and reflects in connected clients,setBoardData C
      onBackgroundColorChange(canvasRef, saveStateToUndoStack, setBoardData)
      //Function below Listen to Server when clear-canvas is emitt,setBoardDataed
      clearCanvasListen(canvasRef, saveStateToUndoStack, setBoardData);
      onShapeColorChange(canvasRef, saveStateToUndoStack, setBoardData);
      //Listener to listen to Undo Emit from Serv,setBoardDataer
      ListenUndo(canvasRef, undoStack, redoStack, saveStateToUndoStack, setBoardData);
      //Listener to listen to Redo Emit from Serv,setBoardDataer
      ListenRedo(canvasRef, undoStack, redoStack, saveStateToUndoStack, setBoardData);
      listenSendToBack(canvasRef, saveStateToUndoStack, setBoardData);
      listenBringToFront(canvasRef, saveStateToUndoStack, setBoardData);
      onStrokeColorChange(canvasRef, saveStateToUndoStack, setBoardData);
      listenUngroup(canvasRef, saveStateToUndoStack, setBoardData);
      listenUpdateAll(id, canvasRef, saveStateToUndoStack, setBoardData);

    }
  }, [canvasRef, saveBoardData, boardFileName, getActiveObject, id, isConflictModalVisible, isLoadingVersion]);

  React.useEffect(() => {

    if (boardData && boardData.length !== 0) {
      const updateDataOnServer = async (data) => {
        const isOffline = !window.navigator.onLine;
        if (isOffline) {
          // Save to localStorage if offline
          saveToLocalStorage(id, data);
          return;
        }

        if (isTemplateDocument) {
          // For template documents, use template update API
          await boardServices.updateBoardData(id, data, setSavingData, true);
        } else {
          await boardServices.updateBoardData(id, data, setSavingData, false);
          // Clear localStorage after successful sync
          removeOfflineData(id);
        }
      };

      let timer = setTimeout(async () => {
        updateDataOnServer(boardData);
      }, 100);

      return () => clearTimeout(timer);

    }
  }, [boardData, undoStack, redoStack, isTemplateDocument]);

  React.useEffect(() => {
    let timer = setTimeout(() => {
      !isOffline() && emitModify(movementData);
      //  console.log("timer function called");
    }, 500)

    return () => clearTimeout(timer);

  }, [movementData])

  return (
    <>
      <CompressionConfirmModal
        open={boardCompressOpen}
        fileSize={boardCompressFileSize}
        onCompress={() => closeBoardCompressModal("compress")}
        onUploadOriginal={() => closeBoardCompressModal("original")}
        onCancel={() => closeBoardCompressModal("cancel")}
        zIndex={BOARD_COMPRESS_MODAL_Z}
        getContainer={() => document.body}
      />
      {contentLoading && <Loader />}
      <div style={{
        pointerEvents: isReadOnly ? 'none' : 'auto',
        visibility: contentLoading ? 'hidden' : 'visible'
      }} id='my-canvas-board'>
        {isReadOnly && userInfo?.userId !== documentInfo?.creator?.id && !conflictPreviewVerion && <WaterMark />}
        <Canvas />
      </div>
    </>
  );
};

export default CanvasWrapper;
